import { createContext, useContext } from "react";

export const FormModelContext = createContext(null);
export const FormEditModeContext = createContext(true);
export const FormActionsContext = createContext([]);
export const FormSubmitHandlerContext = createContext(null);
export const FormProgressModeContext = createContext("lax");
export const FormFlatItemsContext = createContext([]);
export const FormAttachmentsContext = createContext(null);
// { enabled, coverageTypes, objektSparten, validity }: `enabled` is true for
// definitions declaring coverage_types, `coverageTypes` being those
// declarations; `objektSparten` lists the Objekt's Objektsparten with their catalog `sparte_id` and coverage type;
// `validity` is the per-step validation result (see validateCoverageSteps)
// and null while `enabled` is false.
export const FormCoverageContext = createContext({
  enabled: false,
  coverageTypes: [],
  objektSparten: [],
  validity: null,
});
export const FormInspectContext = createContext(null);
// Non-null when rendering a structural preview of a definition/template with
// no real data behind it — gating controls are disabled, so conditionally
// hidden fields must stay visible or they'd never be reachable. Value shape:
// { dependentsByField: Map<fieldName, {name, label}[]> } — see formTreeIds.js.
export const FormPreviewModeContext = createContext(null);

export const useFormModel = () => useContext(FormModelContext);
export const useFormEditMode = () => useContext(FormEditModeContext);
export const useFormActions = () => useContext(FormActionsContext);
export const useFormSubmitHandler = () => useContext(FormSubmitHandlerContext);
export const useFormProgressMode = () => useContext(FormProgressModeContext);
export const useFormFlatItems = () => useContext(FormFlatItemsContext);
export const useFormAttachments = () => useContext(FormAttachmentsContext);
export const useFormCoverage = () => useContext(FormCoverageContext);
export const useFormInspect = () => useContext(FormInspectContext);
export const useFormPreviewMode = () => useContext(FormPreviewModeContext);
